function getAboutAnchorOffset(headerHeight, subnavHeight) {
  return Number(headerHeight || 0) + Number(subnavHeight || 0)
}

function getActiveAboutSection(sectionOffsets, scrollPosition, isAtPageEnd = false) {
  if (!Array.isArray(sectionOffsets) || sectionOffsets.length === 0) {
    return 'company-profile'
  }

  if (isAtPageEnd) {
    return sectionOffsets[sectionOffsets.length - 1].id
  }

  return sectionOffsets.reduce((activeId, section) => {
    return section.top <= scrollPosition ? section.id : activeId
  }, sectionOffsets[0].id)
}

function shouldFixAboutSubnav(scrollPosition, headerHeight) {
  return Number(scrollPosition || 0) >= Number(headerHeight || 0)
}

module.exports = {
  getAboutAnchorOffset,
  getActiveAboutSection,
  shouldFixAboutSubnav
}
